
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 4.757l-2 2V2H7v5H2v11h14v-2.757l2-2v5.765a.993.993 0 01-.993.992H.993A1 1 0 010 18.993V6l6.003-6h10.995C17.55 0 18 .455 18 .992v3.765zm.778 2.05l1.414 1.415L12.414 16l-1.416-.002.002-1.412 7.778-7.778v-.001z","fill":"#FAAD14"}})])
          )
        }
      }
    